// removed by extract-text-webpack-plugin
module.exports = {"container":"_1DXoI","pagination":"_2qSOj","arrow":"_2k2s_","page":"_32H_N","active":"_3DvJo"};


//////////////////
// WEBPACK FOOTER
// ./app/components/pagination-comments/pagination-comments.scss
// module id = 1687
// module chunks = 0